<template>
  <v-container v-if="!$apollo.loading" fill-height fluid grid-list-xl pa-0>
    <v-layout justify-center wrap>
      <v-flex v-if="!_.isEmpty(digitalContractsSigned)" md12>
        <v-data-table
          class="text-no-wrap"
          :headers="headers"
          :items="digitalContractsSigned"
          :hide-default-footer="true"
          :mobile-breakpoint="900"
          :items-per-page="200"
        >
          <template slot="headerCell" slot-scope="{ header }">
            <span v-text="header.text" />
          </template>

          <template #item.name="{ item }">
            <b>{{ item.name }}</b>
          </template>

          <template #item.status="{ item }">
            <b :class="getStatusColor(item.status)">
              {{ getLocalizedStatus(item.status) }}
            </b>
          </template>

          <template #item.signed_at="{ item }">
            {{ item.signed_at | moment("ll") }}
          </template>

          <template #item.actions="{ item }">
            <a
              v-if="item.url"
              :href="item.url"
              target="_blank"
              rel="noopener noreferrer"
              class="text-decoration-none"
            >
              <v-btn outlined text small>
                {{ $t("digitalContracts.view") }}
              </v-btn>
            </a>
            <span v-else class="text--disabled">
              {{ $t("digitalContracts.notAvailable") }}
            </span>
          </template>
        </v-data-table>
      </v-flex>

      <v-flex v-else md12 xs12>
        <v-row>
          <v-col cols="12">
            <v-row justify="center" align="center">
              <v-col>
                <v-card style="padding: 50px" class="text-center">
                  <v-icon size="64" color="grey lighten-1" class="mb-4">
                    mdi-ghost
                  </v-icon>
                  <h3>{{ $t("digitalContracts.myContracts") }}</h3>
                  <p>{{ $t("digitalContracts.noContractsDesc") }}</p>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DIGITAL_CONTRACTS_SIGNED_QUERY from "@/graphql/queries/DigitalContractsSigned.gql";

export default {
  name: "DigitalContractsList",
  components: {},
  data() {
    return {
      digitalContractsSigned: [],
      headers: [
        {
          sortable: false,
          text: this.$t("digitalContracts.contractName"),
          value: "name",
        },
        {
          sortable: false,
          text: this.$t("digitalContracts.status"),
          value: "status",
        },
        {
          sortable: false,
          text: this.$t("digitalContracts.signedAt"),
          value: "signed_at",
        },
        {
          sortable: false,
          text: "",
          value: "actions",
        },
      ],
    };
  },
  methods: {
    getLocalizedStatus(status) {
      // Try to get localized status or return original
      const localizationKey = `digitalContracts.statuses.${status}`;
      const translated = this.$t(localizationKey);

      // If translation not found, return status as is with capitalization
      if (translated === localizationKey) {
        return this.capitalizeFirst(status);
      }

      return translated;
    },

    capitalizeFirst(str) {
      if (!str) return "";
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },

    getStatusColor(status) {
      // All statuses except declined are displayed in green
      if (status === "declined") {
        return "error--text";
      }

      return "success--text";
    },
  },
  apollo: {
    digitalContractsSigned: {
      query: DIGITAL_CONTRACTS_SIGNED_QUERY,
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style lang="scss" scoped>
.text-decoration-none {
  text-decoration: none !important;
}
</style>
